import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 列表页-核心区（数据表+分页）
 * @author alfielv
 */
import _ from 'lodash';
import classnames from 'classnames';
import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { Icon, PageBar, Column, Table } from '@tencent/spaui';
import message from '../../Message';
import NoData from '../../NoData';
import OperationDropDownComponent from './components/OperationDropDown';
import useForceUpdate from '../../../hooks/useForceUpdate';
import useOriginReference from '../../../hooks/useOriginReference';
import Helptip from '../../Helptip'; // 默认pageSize options选项

var DEFAULT_PAGESIZE_OPTIONS = [10, 20, 50]; // spaui table tr 类名匹配表达式

var SPAUI_TABLE_TR_CLASSNAME_REGEXP = /^(.*)(spaui-table-tr-data-even|spaui-table-tr-data-odd)(.*)$/; // pagebar自定义

var PAGEBAR_LOCALE = {
  totalSizeLabel: '共{value}条记录',
  pageSizeChangeLabel: '',
  size: '条/页'
};

var SortIconComponent = function SortIconComponent(_ref) {
  var sortOrder = _ref.sortOrder;
  return /*#__PURE__*/React.createElement("i", {
    className: "column-sort-icon ".concat(sortOrder)
  });
};

export default /*#__PURE__*/React.memo(function (props) {
  var prefixCls = props.prefixCls,
      pageNo = props.pageNo,
      pageSize = props.pageSize,
      tableData = props.tableData,
      loading = props.loading,
      selectKeys = props.selectKeys,
      setPageNo = props.setPageNo,
      setPageSize = props.setPageSize,
      setSelectKeys = props.setSelectKeys,
      tableConfig = props.tableConfig,
      orderBy = props.orderBy,
      orderType = props.orderType,
      setOrderBy = props.setOrderBy,
      setOrderType = props.setOrderType,
      setBatchShow = props.setBatchShow;

  var className = tableConfig.className,
      _tableConfig$pageSize = tableConfig.pageSizeOptions,
      pageSizeOptions = _tableConfig$pageSize === void 0 ? DEFAULT_PAGESIZE_OPTIONS : _tableConfig$pageSize,
      _tableConfig$emptyTex = tableConfig.emptyText,
      emptyText = _tableConfig$emptyTex === void 0 ? '暂无相关数据记录' : _tableConfig$emptyTex,
      columns = tableConfig.columns,
      operations = tableConfig.operations,
      _tableConfig$rowKey = tableConfig.rowKey,
      rowKey = _tableConfig$rowKey === void 0 ? 'id' : _tableConfig$rowKey,
      select = tableConfig.select,
      _tableConfig$paginati = tableConfig.paginationConfig,
      paginationConfig = _tableConfig$paginati === void 0 ? {} : _tableConfig$paginati,
      onSort = tableConfig.onSort,
      useRowExpand = tableConfig.useRowExpand,
      hideExpandColumn = tableConfig.hideExpandColumn,
      fetchExpandData = tableConfig.fetchExpandData,
      _tableConfig$hidePagi = tableConfig.hidePagination,
      hidePagination = _tableConfig$hidePagi === void 0 ? false : _tableConfig$hidePagi,
      bottomTips = tableConfig.bottomTips,
      _tableConfig$enableFi = tableConfig.enableFixedThead,
      enableFixedThead = _tableConfig$enableFi === void 0 ? false : _tableConfig$enableFi,
      _onOptionalChange = tableConfig.onOptionalChange,
      _tableConfig$optional = tableConfig.optionalConfig,
      optionalConfig = _tableConfig$optional === void 0 ? {} : _tableConfig$optional,
      _tableConfig$isLocalP = tableConfig.isLocalPaging,
      isLocalPaging = _tableConfig$isLocalP === void 0 ? false : _tableConfig$isLocalP,
      tableProps = _objectWithoutProperties(tableConfig, ["className", "pageSizeOptions", "emptyText", "columns", "operations", "rowKey", "select", "paginationConfig", "onSort", "useRowExpand", "hideExpandColumn", "fetchExpandData", "hidePagination", "bottomTips", "enableFixedThead", "onOptionalChange", "optionalConfig", "isLocalPaging"]);

  var onClickTr = tableProps.onClickTr;
  var columnsCount = useRef(0); // 存储column Keys,用于自定义列变化时，多执行一次手动render处理spaui table列宽问题

  var prevColumnKeysRef = useRef(_.map(columns, 'name'));
  var forceUpdate = useForceUpdate(); // 扩展区域数据

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      expandOptions = _useState2[0],
      setExpandOptions = _useState2[1]; // 表格数据


  var _ref2 = tableData || {},
      _ref2$list = _ref2.list,
      originDataSource = _ref2$list === void 0 ? [] : _ref2$list,
      pageInfo = _ref2.page_info;

  var isTriggerLocalPaging = useMemo(function () {
    // 如果tableData中无分页信息且配置了要本地分页的
    return !pageInfo && isLocalPaging;
  }, [pageInfo, isLocalPaging]);

  var _ref3 = function () {
    if (isTriggerLocalPaging) {
      var startIndex = (pageNo - 1) * pageSize;
      return {
        totalNumber: originDataSource.length,
        dataSource: originDataSource.slice(startIndex, startIndex + pageSize)
      };
    }

    return {
      totalNumber: _.get(pageInfo, 'total_number', 0),
      dataSource: originDataSource
    };
  }(),
      totalNumber = _ref3.totalNumber,
      dataSource = _ref3.dataSource; // 更新pageNo


  var handlePageNoChange = useCallback(function (_event, value) {
    setPageNo(value);
  }, [setPageNo]); // 更新pageSize

  var handlePageSizeChange = useCallback(function (value, pageSize) {
    setPageNo(value);
    setPageSize(pageSize);
  }, [setPageNo, setPageSize]); // 更新排序信息

  var handleSortChange = useCallback(function (event, sortName, sortOrder) {
    setOrderBy(sortName);
    setOrderType(sortOrder);
    onSort === null || onSort === void 0 ? void 0 : onSort(event, sortName, sortOrder);
  }, [setOrderBy, setOrderType, onSort]); // 更新展开数据

  var updateExpandOptions = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var index, _newData, additionalData, newData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!useRowExpand || data.expandDisabled)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;
              // 当前行是否已展开
              index = _.findIndex(expandOptions, function (tarExpandOpt) {
                var targetKey = tarExpandOpt[rowKey];
                return targetKey === data[rowKey];
              });

              if (!(index > -1)) {
                _context.next = 8;
                break;
              }

              // 当前行已展开，删除展开数据
              setExpandOptions(function (prev) {
                var newExpandOptions = _toConsumableArray(prev);

                newExpandOptions.splice(index, 1);
                return newExpandOptions;
              });
              _context.next = 16;
              break;

            case 8:
              if (fetchExpandData) {
                _context.next = 11;
                break;
              }

              console.error('ListView TableConfig 扩展数据类型，必须定义fetchExpandData！');
              return _context.abrupt("return");

            case 11:
              _context.next = 13;
              return fetchExpandData(data);

            case 13:
              additionalData = _context.sent;
              // 新的扩展数据
              newData = (_newData = {}, _defineProperty(_newData, rowKey, data[rowKey]), _defineProperty(_newData, "_additional", true), _defineProperty(_newData, "_additionalData", _.map(additionalData, function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  trClassName: data.trClassName
                });
              })), _newData);
              setExpandOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [newData]);
              });

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](2);
              message.error(_context.t0.message);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 18]]);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [expandOptions, fetchExpandData, rowKey, useRowExpand]); // 可进行行扩展时的table ———— 行点击

  var handleTrClick = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event, type, data) {
      var curClassName, oddEvenClassName;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.stopPropagation();
              onClickTr === null || onClickTr === void 0 ? void 0 : onClickTr(event, type, data); // 点击可扩展一级行

              if (useRowExpand && type === 'data') {
                curClassName = _.get(event, 'currentTarget.className', '');
                oddEvenClassName = curClassName.replace(SPAUI_TABLE_TR_CLASSNAME_REGEXP, '$2');
                updateExpandOptions(_objectSpread(_objectSpread({}, data), {}, {
                  // 保存当前可扩展行的even/odd类名
                  trClassName: oddEvenClassName
                }));
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }(), [useRowExpand, updateExpandOptions, onClickTr]); // 设置行类名

  var setTrClassName = useCallback(function (type, data) {
    if (type === 'additional') {
      var additionalTrClassName = data.trClassName;
      return _.isEmpty(data) ? 'tr-expand-loading' : additionalTrClassName;
    }

    if (type === 'data') {
      // 行可点击
      if (!data.expandDisabled) {
        return 'tr-clickable';
      }
    }
  }, []);
  useEffect(function () {
    // 列表数据发生改变，重置扩展数据
    if (useRowExpand) {
      setExpandOptions([]);
    }
  }, [dataSource, useRowExpand]);
  var tableClassNames = classnames(className, {
    'table-has-expand': useRowExpand // 拥有展开行的表格

  });
  var renderOperationAction = useCallback(function (tableInfo, item) {
    var type = tableInfo.type,
        name = tableInfo.name,
        value = tableInfo.value,
        data = tableInfo.data;
    var _item$label = item.label,
        label = _item$label === void 0 ? '' : _item$label,
        action = item.action,
        disabled = item.disabled,
        tip = item.tip,
        labelProps = item.props; // 处理埋点

    var eventTrace = _.get(action, 'eventTrace.target', {});

    var eventExtraInfo = _.get(action, 'eventTrace.extra', {});

    var eventTraceProps = _.reduce(eventTrace, function (result, value, key) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, "data-event-trace-".concat(key), value));
    }, {});

    var eventExtraProps = _.reduce(eventExtraInfo, function (result, value, key) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, "data-event-extra-".concat(key), value));
    }, {}); // 基于类型的action属性


    var actionProps = function () {
      if (disabled) {
        return {};
      }

      if (action.type === 'custom') {
        return {
          onClick: function onClick(event) {
            event.stopPropagation();
            action.onClick(type, name, value, data);
          }
        };
      }

      if (action.type === 'link') {
        var openInNewPage = _.get(action, 'openInNewPage', true);

        return {
          href: action.href,
          target: openInNewPage ? '_blank' : ''
        };
      }

      return {};
    }();

    return /*#__PURE__*/React.createElement("span", {
      key: label,
      className: classnames('table-operation', {
        'table-operation--disabled': disabled
      })
    }, /*#__PURE__*/React.createElement("a", _extends({}, eventTraceProps, eventExtraProps, actionProps, labelProps, {
      className: classnames('table-operation__label', labelProps === null || labelProps === void 0 ? void 0 : labelProps.className)
    }), label), !_.isNil(tip) && /*#__PURE__*/React.createElement(Helptip, {
      content: tip
    }));
  }, []); // 顶部导航栏的高度

  var getCssFixedTheadSpace = useCallback(function () {
    var navElement = document.querySelector('.crm-topNav');
    return _.get(navElement, 'offsetHeight', 0);
  }, []);

  var fixedTheadProps = function () {
    // 只有一行数据时，SPAUI Table的宽度定义失效，初步断定由cssFixedTheadAble和cssFixedTotalAble引起
    // 遂在只有一行数据时，将此对参数设置为false。
    // P.S. 只有一行数据时，表头列和横向滚动条均能在页面中展示，无需fixed
    var isOneLineData = dataSource.length > 1;

    var currentColumnsLength = _.get(columns, 'length', 0); // 自定义列发生变化时，需【异步】调整列宽（false）
    // --> 通常为【同步】（true），否则会由于【调整宽度异步化】使得【设置固定列的偏移】不正确导致抖动


    var adjustWidthSync = columnsCount.current === currentColumnsLength;
    columnsCount.current = currentColumnsLength; // 更新ref存储信息

    return {
      scrollTarget: 'body',
      cssFixedTheadAble: isOneLineData,
      cssFixedTotalAble: isOneLineData,
      setCssFixedTheadSpace: getCssFixedTheadSpace,
      adjustWidthSync: adjustWidthSync
    };
  }(); // Table组件列宽问题。手动执行column keys变化后的render


  useEffect(function () {
    var newColumnsKeys = _.map(columns, 'name');

    if (!_.isEqual(prevColumnKeysRef.current, newColumnsKeys)) {
      prevColumnKeysRef.current = newColumnsKeys;
      setTimeout(function () {
        forceUpdate();
      }, 0);
    }
  }, [columns, forceUpdate]); // 批量选择列
  // eslint-disable-next-line @typescript-eslint/naming-convention

  var SelectionColumn = useMemo(function () {
    return /*#__PURE__*/React.createElement(Column, _extends({
      type: "optional",
      target: rowKey // 指定key对应属性
      ,
      multiple: select === 'multiple',
      value: selectKeys,
      fixedable: true
    }, optionalConfig, {
      onOptionalChange: function onOptionalChange(_event, value, data, dataMap, clickArea) {
        var _optionalConfig$onOpt;

        _onOptionalChange === null || _onOptionalChange === void 0 ? void 0 : _onOptionalChange(_event, value, data, dataMap, clickArea);
        optionalConfig === null || optionalConfig === void 0 ? void 0 : (_optionalConfig$onOpt = optionalConfig.onOptionalChange) === null || _optionalConfig$onOpt === void 0 ? void 0 : _optionalConfig$onOpt.call(optionalConfig, _event, value, data, dataMap, clickArea);
        setSelectKeys(value);
        setBatchShow(value.length > 0);
      }
    }));
  }, [rowKey, selectKeys, select, setSelectKeys, setBatchShow, _onOptionalChange, optionalConfig]); // 普通列
  // eslint-disable-next-line @typescript-eslint/naming-convention

  var NormalColumns = useMemo(function () {
    return _.map(columns, function (column) {
      if (!column) {
        return;
      }

      var title = column.title,
          _render = column.render,
          customRender = column.customRender,
          columnProps = _objectWithoutProperties(column, ["title", "render", "customRender"]);

      return /*#__PURE__*/React.createElement(Column, _extends({
        key: columnProps.name + title,
        alwaysShowSortIcon: true,
        SortIconComponent: SortIconComponent
      }, columnProps, _render || customRender ? {
        render: function render(type, name, value, data, checkedValue, disabled) {
          // 外部定义customRender，使用spaui原生render函数渲染
          if (customRender) {
            return customRender(type, name, value, data, checkedValue, disabled);
          } // 数据区域render定义，表头直接返回


          if (_render && _.includes(['data', 'total', 'additional'], type)) {
            return _render(type, name, value, data, checkedValue, disabled);
          }

          return value;
        }
      } : {}), title);
    });
  }, [columns]); // 操作列

  var operationsOrginRef = useOriginReference(operations); // eslint-disable-next-line @typescript-eslint/naming-convention

  var OperationColumn = useMemo(function () {
    if (!_.isPlainObject(operationsOrginRef)) {
      return null;
    }

    var _ref6 = operationsOrginRef || {},
        columnAction = _ref6.columnAction,
        _ref6$title = _ref6.title,
        title = _ref6$title === void 0 ? '操作' : _ref6$title,
        operationsProps = _objectWithoutProperties(_ref6, ["columnAction", "title"]);

    var operationClassName = _.get(operationsProps, 'className', '');

    return /*#__PURE__*/React.createElement(Column, _extends({
      name: "default_operation",
      fixedable: true,
      fixedAlign: "right"
    }, operationsProps, {
      className: classnames("".concat(prefixCls, "__main-area__operation-column"), operationClassName),
      render: function render(type, name, value, data) {
        if (type === 'data' || type === 'additional') {
          var operationRenderResult = _.isFunction(columnAction) ? columnAction(data) : columnAction;
          return _.map(_.compact(operationRenderResult), function (item) {
            // 单项操作
            if ('action' in item) {
              return renderOperationAction({
                type: type,
                name: name,
                value: value,
                data: data
              }, item);
            } // 折叠下拉操作


            if ('options' in item) {
              var _item$title = item.title,
                  _title = _item$title === void 0 ? '' : _item$title,
                  options = item.options,
                  labelProps = item.props;

              return /*#__PURE__*/React.createElement(OperationDropDownComponent, {
                key: _title,
                title: _title,
                tableInfo: {
                  type: type,
                  name: name,
                  value: value,
                  data: data
                },
                options: options,
                labelProps: labelProps,
                actionHandler: renderOperationAction
              });
            } // 否则直接返回外部自定义


            return item;
          });
        }

        return value;
      }
    }), title);
  }, [operationsOrginRef, renderOperationAction, prefixCls]); // 展开状态列
  // eslint-disable-next-line @typescript-eslint/naming-convention

  var ExpandColumn = useMemo(function () {
    return /*#__PURE__*/React.createElement(Column, {
      name: "expand-arrow",
      dataClassName: "expand-arrow-td",
      width: "44",
      minWidth: "44",
      maxWidth: "44",
      align: "center",
      fixedable: true,
      fixedAlign: "right",
      render: function render(type, _name, value, data) {
        // 数据区域render定义，表头直接返回
        if (type === 'data' && !data.expandDisabled) {
          return /*#__PURE__*/React.createElement(Icon, {
            name: "dropdown-arrow-outlined"
          });
        }

        return value;
      }
    }, "\u5C55\u5F00");
  }, []); // 剩余透传tableProps

  var restTableProps = useMemo(function () {
    if (useRowExpand && _.has(tableProps, 'onClickTr')) {
      return _.omit(tableProps, ['onClickTr']);
    }

    return tableProps;
  }, [useRowExpand, tableProps]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__main-area")
  }, /*#__PURE__*/React.createElement(Table, _extends({
    className: classnames(tableClassNames, 'spaui-table-light'),
    striped: true,
    bordered: false,
    data: dataSource,
    loading: loading,
    hideScrollBar: loading,
    EmptyComponent: function EmptyComponent() {
      return /*#__PURE__*/React.createElement(NoData, {
        content: emptyText
      });
    }
  }, enableFixedThead && fixedTheadProps, useRowExpand && {
    expandOptions: expandOptions,
    onClickTr: handleTrClick,
    showExpandComponent: false,
    setTrClassName: setTrClassName
  }, restTableProps, {
    sortName: orderBy,
    sortOrder: orderType,
    onSort: handleSortChange
  }), (select === 'multiple' || select === 'single') && SelectionColumn, NormalColumns, operations && OperationColumn, useRowExpand && !hideExpandColumn && ExpandColumn), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__main-area__footer")
  }, bottomTips && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__main-area__footer-left")
  }, bottomTips), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__main-area__footer-right")
  }, !hidePagination && /*#__PURE__*/React.createElement(PageBar, _extends({
    locale: PAGEBAR_LOCALE,
    showTotalPage: false,
    value: pageNo,
    pageSize: pageSize,
    totalSize: totalNumber,
    pageSizeList: pageSizeOptions,
    selectPlacement: "top"
  }, paginationConfig, {
    onChange: handlePageNoChange,
    onPageSizeChange: handlePageSizeChange
  })))));
});